<template>
  <div id="zt8225">
    <div id="z1">
      <div>ZT8225  手持POS</div>
      <label>经典Linux POS，高效稳定，焕发新春</label>
      <img :src="require('@/assets/pic/zt8225/bg1icon.png')" />
    </div>
    <div id="z2">
      <label>ZT8225是一款传统手持POS终端，该终端外观精美，功能强大，操作方便；广泛应用于商超、零售、保险、交通缴费等支付场景。</label>
    </div>
    <div id="z3">
      <div>海纳应用  为你所需</div>
      <label>丰富的应用商店，满足多行业应用需求</label>
    </div>
    <div id="z4">
      <div>插刷挥扫  无所不能</div>
      <label>支持多种银行卡读取方式</label>
    </div>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      spdata: {
        file: 'ZT8225',
        data: [
          {label: _this.$t('lang.cpu'), desc: ['32位高性能通用处理器',_this.$t('lang.cpu32bsafe')],pic: 'cpu.png'},
          {label: _this.$t('lang.memory'), desc: ['64MB RAM+128MB ROM'],pic: 'ram.png'},
          {label: _this.$t('lang.os'), desc: ['ZLinux 2.6'], pic: 'sys.png'},
          {label: _this.$t('lang.algor'), desc: [_this.$t('lang.sptalgs')], pic: 'safe.png'},
          {label: _this.$t('lang.display'), desc: ['3.5英寸240×320 TFT LCD，带背光'], pic: 'disp.png'},
          {label: '触摸屏', desc: ['电阻触摸屏'],pic: 'touch.png'},
          {label: _this.$t('lang.cardread'), desc: [_this.$t('lang.msrd1untic1'),_this.$t('lang.untic1psam2')], pic: 'read.png'},
          {label: _this.$t('lang.printer'), desc: [_this.$t('lang.in58mmhsprt'),'打印速度16行/秒','纸卷外径30mm'], pic: 'prt.png'},
          {label: _this.$t('lang.wan'), desc: ['Ethernet 或 Modem（二选一）'], pic: 'ethr1.png'},
          {label: _this.$t('lang.mobinet'), desc: ['1个标准SIM卡卡槽', '支持：GSM / WCDMA / CDMA2000'], pic: 'mobi.png'},
          {label: _this.$t('lang.port'), desc: ['Mini USB×1（串口）','USB OTG×1'], pic: 'port.png'},
          {label: _this.$t('lang.keyboard'), desc: ['密码键盘（20个物理按键）','按键寿命超过30万次'], pic: 'keyb.png'},
          {label: '扫码器（选配）', desc: [_this.$t('lang.spkofcode')], pic: 'scan.png'},
          {label: _this.$t('lang.speaker'), desc: ['内置扬声器，功率0.5 W'], pic: 'speaker.png'},
          {label: _this.$t('lang.bettery'), desc: ['锂电池 7.4V/1850mAh'], pic: 'battery.png'},
          {label: _this.$t('lang.adapter'), desc: [_this.$t('lang.inputac100240'),'输出：DC 9.0V/3A'], pic: 'char.png'},
          {label: _this.$t('lang.size'), desc: ['228mm×87mm×66mm'], pic: 'size.png'},
          {label: _this.$t('lang.suitenv'), desc: [_this.$t('lang.wktemp050')], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8225 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8225/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.92rem;
  color: white;
}
#z1 div {
  margin-top: 2.94rem;
  font-size: .6rem;
  font-weight: bold;
}
#z1 label {
  display: block;
  font-weight: 400;
  margin-top: .17rem;
  margin-bottom: .26rem;
  font-size: .3rem;
}
#z1 img {
  width: 3.5rem;
}
#z2 {
  height: 1.78rem;
  background: #3D3C3C ;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 7.17rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8225/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.84rem;
  color: white;
}
#z3 div {
  margin: 3.23rem 0 .2rem 0;
  font-size: .56rem;
  font-weight: bold;
}
#z3 label {
  margin-left: .05rem;
  width: 5.4rem;
  display: block;
  font-size: .3rem;
  font-weight: 400;
  color: #F4F4F4 ;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8225/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.85rem;
}
#z4 div {
  margin: 2.47rem 0 .14rem 0;
  font-size: .63rem;
  font-weight: bold;
  color: #333333;
}
#z4 label {
  margin-left: .05rem;
  width: 5.2rem;
  display: block;
  font-size: .3rem;
  font-weight: 400;
  color: #333333;
}
</style>
